import PropTypes from 'prop-types';

import { useContext, useEffect } from 'react';

import FormulationPickerContext from '../../context/materialcapture/FormulationPickerContext';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const FormulationPicker = ({ getLipids, showApplyBtn }) => {
  const { 
    formulationsObj, setFormulationsObj, formulationsArray, 
    formErrors, setFormulationFormErrors, isSubmit, setIsSubmit, validate,
  } = useContext(FormulationPickerContext);

  const handleTypeChange = e => {
    setFormulationsObj(prev => ({
      ...prev,
      type: e.target.value,
      ids: [],
    }));    
  };

  const handleFormulationPickerSubmit = () => {    
    setFormulationFormErrors(validate());
    setIsSubmit(true);
  };

  useEffect(() => {    
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      getLipids();
    }
  }, [formErrors]);

  const handleClick = () => {
    if (handleFormulationPickerSubmit()) {                
      getLipids();
    }
  };

  return(
    <Box sx={{width: '100%'}}>
      <Typography 
        variant="h6" 
        component="h6"
        color={'text.secondary'}
        sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}
      >
        Formulations
      </Typography>
      
      <Stack 
        direction='row' 
        sx={{ 
          justifyContent: showApplyBtn ? 'space-between' : '', 
          mr: 10,
          ml: 10 
        }}
      >
        <Box m={1}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="formulationsLabel"
              name="formulations"
              value={formulationsObj?.type}
              onChange={handleTypeChange}
            >
              <FormControlLabel value="Plate" control={<Radio />} label="Plate" />
              <FormControlLabel value="LNP Sample" control={<Radio />} label="LNP Sample" />
            </RadioGroup>
          </FormControl>
        </Box>
        
        <Box sx={{ width: 800 }}>
          <Autocomplete
            multiple
            id="formulationDrpDwn"
            options={formulationsArray}
            getOptionLabel={(option) => option?.name}
            value={formulationsObj?.ids}
            onChange={(event, newValue) => {
              setFormulationsObj(prev => ({...prev, ids: newValue}));
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label={`${formulationsObj?.type} *`} 
                placeholder="Formulation"
                helperText={formErrors['formulation']}
                error={'formulation' in formErrors}
              />
            )}
            fullWidth
          />
        </Box>

        {showApplyBtn && 
          <Box m={1}>
            <Button 
              variant='contained' 
              color='info' 
              onClick={handleClick}
            >
              Apply
            </Button>
          </Box>
        }
      </Stack>
    </Box>
  );
};

FormulationPicker.propTypes = {
  showApplyBtn: PropTypes.bool.isRequired,
  getLipids: PropTypes.func,
};

export default FormulationPicker;